import { observer } from 'mobx-react-lite';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toastStore } from '@/stores/toast.store';
import type { ToastType } from '@/stores/toast.store';

const icons: Record<ToastType, React.ReactNode> = {
  success: <CheckCircle2 className='w-4 h-4 text-emerald-400 shrink-0 mt-0.5' />,
  error: <AlertCircle className='w-4 h-4 text-red-400    shrink-0 mt-0.5' />,
  info: <Info className='w-4 h-4 text-primary     shrink-0 mt-0.5' />,
};

export const Toaster = observer(() => (
  <div className='fixed bottom-6 right-6 z-50 flex flex-col gap-2 items-end pointer-events-none'>
    <AnimatePresence initial={false}>
      {toastStore.items.map((toast) => (
        <motion.div
          key={toast.id}
          layout
          initial={{ opacity: 0, y: 16, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 8, scale: 0.96 }}
          transition={{ duration: 0.2 }}
          className='pointer-events-auto flex items-start gap-3 w-80 rounded-2xl border border-border/50 bg-card px-4 py-3 shadow-xl shadow-black/20'
        >
          {icons[toast.type]}
          <p className='flex-1 text-sm text-foreground leading-snug'>{toast.message}</p>
          <Button
            variant='ghost'
            size='icon'
            onClick={() => toastStore.dismiss(toast.id)}
            className='shrink-0 p-0 h-auto w-auto text-muted-foreground hover:text-foreground hover:bg-transparent'
          >
            <X className='w-3.5 h-3.5' />
          </Button>
        </motion.div>
      ))}
    </AnimatePresence>
  </div>
));
